import type { MouseEvent } from 'react';
import { cn } from '@/lib/utils';

/**
 * The shared direct-open affordance (▤) — the ONE place the "open the document
 * detail" icon button lives, used by BOTH lenses (the calendar chip and the
 * register row) so the affordance looks and behaves identically (L14). It stops
 * propagation so it never starts a chip drag or triggers an enclosing row-click,
 * and is non-draggable so it does not hijack the chip's own drag.
 */
export function DirectOpenButton({
  onOpen,
  label,
  className,
}: {
  /** Open the document detail for this entry. */
  onOpen: () => void;
  /** The entry's party / title, for the accessible label. */
  label: string;
  className?: string;
}) {
  return (
    <button
      type="button"
      draggable={false}
      onClick={(ev: MouseEvent) => {
        ev.stopPropagation();
        onOpen();
      }}
      aria-label={`Ava dokument · ${label}`}
      className={cn(
        'shrink-0 select-none rounded px-0.5 text-foreground/40 transition-colors hover:text-primary',
        className,
      )}
    >
      <span aria-hidden>▤</span>
    </button>
  );
}
